import React from 'react';

export const pageMeta = {
  "name": "Function Arrows",
  "link": "/javascript/functions/arrows"
};

export default function JavascriptFunctionsArrows() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Function Arrows</h2>
      <p>Route: /javascript/functions/arrows</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
